import React, { useEffect } from "react";
import { Link, useParams, useHistory } from "react-router-dom";
import { Table, Space, PageHeader, Button } from "antd";
import { reverse } from "named-urls";
import { useDispatch, useSelector } from "react-redux";
import { useInjectReducer, useInjectSaga } from "redux-injectors";
import { sliceKey, reducer, actions } from "./slice";
import { companyUserSaga } from "./saga";
import * as selectors from "./selectors";
import routes from "../../../../../routes";
import { useAuth } from "../../../../contexts/auth";

const { Column } = Table;

const CompanyUserListing = () => {
  useInjectReducer({ key: sliceKey, reducer: reducer });
  useInjectSaga({ key: sliceKey, saga: companyUserSaga });
  const dispatch = useDispatch();
  const { companyId } = useParams();
  const history = useHistory();
  const auth = useAuth();
  const user = auth.loggedInUser;
  const userRole = user.role;

  useEffect(() => {
    dispatch(actions.fetchCompanyUsers({ id: companyId }));
  }, [dispatch, companyId]);

  const companyDetails = useSelector(selectors.selectCompanyDetails) || {};

  const { users = [] } = companyDetails;

  const tableData = [
    ...[...users].map((user) => ({
      id: user._id,
      name: `${user.firstName} ${user.lastName}`,
      role: user.role === "company_user" ? "User" : "Admin",
      department: user.department,
      designation: user.designation,
    })),
  ];

  const handleBack = () => {
    history.push(routes.backOffice.users);
    // history.goBack();
  };

  return (
    <div style={{ height: "100%" }}>
      <PageHeader
        onBack={auth.isCompanyAdmin ? null : handleBack}
        ghost={false}
        title="User Accounts"
        subTitle={companyDetails.companyName}
        extra={[
          userRole !== "support_team" && (
          <Button key="1" type="primary">
            <Link
              to={reverse(routes.backOffice.companies.details.users.new, {
                companyId,
              })}
            >
              Add User
            </Link>
          </Button>
          )
        ]}
      />
      <div
        style={{
          height: "calc(100vh - 137px)",
          overflowY: "auto",
          padding: 24,
        }}
      >
        <Table dataSource={tableData}>
          <Column title="Name" dataIndex="name" key="name" />
          <Column title="Role" dataIndex="role" key="role" />
          <Column title="Department" dataIndex="department" key="department" />
          <Column
            title="Designation"
            dataIndex="designation"
            key="designation"
          />
          <Column
            title="Action"
            key="action"
            render={(text, record) => (
              <Space size="middle">
                <Link
                  to={reverse(routes.backOffice.companies.details.users.view, {
                    companyId,
                    userId: record.id,
                  })}
                >
                  View
                </Link>
                {userRole !== "support_team" && (
                <Link
                  to={reverse(routes.backOffice.companies.details.users.edit, {
                    companyId,
                    userId: record.id,
                  })}
                >
                  Edit
                </Link>
                )}
              </Space>
            )}
          />
        </Table>
      </div>
    </div>
  );
};

export default CompanyUserListing;
